import TextScript from "../misc/text-script";

class ExternalSignalReceiver extends TextScript {
    until;
    prune;
    _stopper;

    constructor(props) {
        super(props);
        this.until = props.until || 600000;
        this.prune = props.prune || {};
        this.id = generateUUID();
        this.variable = null;
        this._stopper = () => {
        };
    }

    async execute(eventLoop) {
        let self = this;
        const match = this.script.match(/\(get (\w+)\)/);

        if (match) {
            this.variable = match[1];
        }
        
        externalSignalReceiverManager.addExternalSignalReceiverAction(this);
        this._stopper = activateExternalSignalReceiver();
        setTimeout(this._stopper, self.until - self.startTime);

        function activateExternalSignalReceiver() {
            document.addEventListener('activate_externalSignalReceiver', handleExternalSignalReceiver);
            return () => {
                document.removeEventListener('activate_externalSignalReceiver', handleExternalSignalReceiver);
            }
        }

        const textScriptExecute = super.execute.bind(this);

        async function handleExternalSignalReceiver(event) {
            if (self.variable !== event.detail.variable) return;
            eventLoop.training.registry.set(event.detail.variable, event.detail.value);

            return await textScriptExecute(eventLoop);
        }
    }

    stopExternalSignalReceiver() {
        if (this._stopper) {
            this._stopper();
        }
    }
}

export default ExternalSignalReceiver;